module.exports = __webpack_public_path__ + "img/general.68dca095.webp";